



<!-- <div class="d-flex" id="wrapper"> -->
  <!-- Sidebar -->
  <!-- <div class="bg-light border-right" id="sidebar-wrapper">
    <div class="sidebar-heading">Therichpost </div>
    <div class="list-group list-group-flush">
      <a class="nav-link" routerLink="/plants" routerLinkActive="active" class="list-group-item list-group-item-action bg-light">Sucursal</a>
      <a class="nav-link" routerLink="/centroCosto" routerLinkActive="active" class="list-group-item list-group-item-action bg-light">Centro de costo</a>
      <a class="nav-link" routerLink="/fuenteContrato" routerLinkActive="active" class="list-group-item list-group-item-action bg-light">Fuentes de Contrato</a>
      <a class="nav-link" routerLink="/personal" routerLinkActive="active" class="list-group-item list-group-item-action bg-light">Personal</a>
      <a class="nav-link" routerLink="/dashboard" routerLinkActive="active" class="list-group-item list-group-item-action bg-light">Dashboard</a>
      <a class="nav-link" routerLink="/users" routerLinkActive="active" class="list-group-item list-group-item-action bg-light">Usuarios</a>
      <a class="nav-link" routerLink="/roles" routerLinkActive="active" class="list-group-item list-group-item-action bg-light">Roles</a>

      <a class="nav-link" routerLink="/dictionarys" routerLinkActive="active" class="list-group-item list-group-item-action bg-light">Diccionario</a>
      <a href="#" class="list-group-item list-group-item-action bg-light">Status</a>
    </div>
  </div> -->
  <!-- /#sidebar-wrapper -->
  <!-- Page Content -->

  <!-- /#page-content-wrapper -->
<!-- </div> -->
<!-- /#wrapper -->


     <!-- ============================================================== -->
        <!-- Left Sidebar - style you can find in sidebar.scss  -->
        <!-- ============================================================== -->
<aside class="left-sidebar">
<!-- Sidebar scroll-->
<div class="scroll-sidebar">
<!-- Sidebar navigation-->
<nav class="sidebar-nav">
<ul id="sidebarnav">
<li class="user-profile">
    <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false"><img src="./assets/images/users/img1.png" alt="user" /><span class="hide-menu">User </span></a>
    <ul aria-expanded="false" class="collapse">

        <li><a href="javascript:void()">Logout</a></li>
    </ul>
</li>
<li class="nav-devider"></li>
<!-- <li class="nav-small-cap">PERSONAL</li> -->
<li> <a class="has-arrow waves-effect waves-dark" href="#" aria-expanded="false"><i class="mdi mdi-gauge"></i><span class="hide-menu">Dashboard </span></a>
    <ul aria-expanded="false" class="collapse">
        <li><a  routerLink="/capture" routerLinkActive="active" >Capturar </a></li>
        <!-- <span class="label label-rouded label-themecolor pull-right"></span> -->
        <!-- <li><a  routerLink="/scanner" routerLinkActive="active" >Scanner </a></li> -->
        <!-- <li><a  routerLink="/users" routerLinkActive="active" >Usuarios </a></li> -->
        <!-- <li><a  routerLink="/profile" routerLinkActive="active">Perfil</a></li> -->
        <!-- <li><a  routerLink="/roles" routerLinkActive="active">Roles</a></li> -->
        <!-- <li><a routerLink="/plants" routerLinkActive="active">Plantas</a></li> -->
        <!-- <li><a routerLink="/dictionarys" routerLinkActive="active">Diccionario</a></li> -->
        <!-- <li><a routerLink="/centroCosto" routerLinkActive="active">Centro de Costos</a></li> -->
        <!-- <li><a routerLink="/fuenteContrato" routerLinkActive="active">Fuente de contrato</a></li> -->
        <!-- <li><a routerLink="/personal" routerLinkActive="active">Personal</a></li> -->

    </ul>
</li>




</ul>
</nav>
<!-- End Sidebar navigation -->
</div>
<!-- End Sidebar scroll-->
</aside>
      <!-- ============================================================== -->
      <!-- End Left Sidebar - style you can find in sidebar.scss  -->
      <!-- ============================================================== -->


